import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';

export const LANGUAGES = ['en', 'ru'] as const;
export type Language = (typeof LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<Language, string> = {
  en: 'English',
  ru: 'Русский',
};

const STORAGE_KEY = 'gamecompass.language';

/**
 * The device's choice, not the account's.
 *
 * Stored beside the theme (`gamecompass.theme`) and for the same reason: the sign-in page
 * has to know which language to speak before it knows who is speaking.
 */
export function storedLanguage(): Language {
  const saved = typeof localStorage === 'undefined' ? null : localStorage.getItem(STORAGE_KEY);

  if (saved && (LANGUAGES as readonly string[]).includes(saved)) {
    return saved as Language;
  }

  // Only the primary subtag: "ru-RU" and "ru" are the same language to us, and matching the
  // whole tag would send a Russian speaker to English over a region we do not care about.
  const browser = typeof navigator === 'undefined' ? 'en' : navigator.language.split('-')[0];

  return (LANGUAGES as readonly string[]).includes(browser) ? (browser as Language) : 'en';
}

export function setLanguage(language: Language) {
  localStorage.setItem(STORAGE_KEY, language);
  void i18next.changeLanguage(language);
}

void i18next.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru } },
  lng: storedLanguage(),
  // English is the language every key is written in first, so a Russian key that has not
  // been added yet shows English rather than the key itself.
  fallbackLng: 'en',
  interpolation: {
    // React escapes what it renders; doing it again turns an apostrophe into "&#39;".
    escapeValue: false,
  },
});

export default i18next;
